<template>

  <v-app id="inspire">
    <v-content>
      <v-container class="pa-2">

        <v-row>
          <v-col>
            <template>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                mobile-breakpoint="100"
                dence
                >

                <template v-slot:top>

                  <v-toolbar flat color="white">
                    <v-toolbar-title>シフト変更履歴 - <span class="ym"> {{calday.year()}}年{{calday.month()+1}}月 </span></v-toolbar-title>
                  </v-toolbar>

                  <v-toolbar flat>
                    <v-col>
                      <div id="calendar-nav" style="width:120px;">
                        <v-btn small class="glyphicon glyphicon-menu-left" @click="moveLastMonth()">
                          <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                        
                        <v-btn small class="glyphicon glyphicon-menu-right"  @click="moveNextMonth()">
                          <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                      </div>
                    </v-col>

                    <v-card>
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="検索"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                    </v-card>
                  </v-toolbar>

                </template>

                <template v-slot:item.henkou="{ item }">

                  <v-chip
                    color="primary"
                    v-if="item.log == 2 && item.del == 0"
                  >追加</v-chip>

                  <v-chip
                    v-if="item.log == 0 && item.del == 0"
                  >更新前</v-chip>

                  <v-chip
                    color="green"
                    text-color="white"
                    v-if="item.log == 1 && item.del == 0"
                  >更新後</v-chip>

                  <v-chip
                    color="red"
                    text-color="white"
                    v-if="item.log == 1 && item.del == 1"
                  >削除</v-chip>

                </template>

                <template v-slot:no-data>
                </template>
              </v-data-table>
            </template>

          </v-col>
        </v-row>


    </v-container>
  </v-content>
</v-app>
</template>

<script>
import Common from '@/components/Common'
import moment from 'moment'
export default {
  mixins: [ Common ],
  data: () => ({
    dialog: false,
    headers: [
      { text: '変更', value: 'henkou', width: '100px' },
      { text: '更新日', value: 'modified', width: '120px' },
      { text: '更新者 ', value: 'updid', width: '100px' },
      { text: '利用者名', value: 'riname', width: '120px'},
      { text: '日付', value: 'hiduke', width: '140px' },
      { text: '開始', value: 'kaisi', width: '100px' },
      { text: '終了', value: 'syuryo', width: '100px' },
      { text: '担当', value: 'staffname', width: '100px'},
    ],
    items: [],
    menu: false,
    search: '',
    calday: moment().date(1),
    caldata: [],
    msg: '',
    snackbar: '',
    services: []
  }),

  computed: {
  },

  watch: {
  },

  created () {
    this.kousin()
  },

  mounted () {
  },

  methods: {
    moveLastMonth: function () {
      this.keyid = 0
      this.calday.add(-1, 'months')
      this.kousin()
    },
    moveNextMonth: function () {
      this.keyid = 0
      this.calday.add(1, 'months')
      this.kousin()
    },
    getServices () {
      this.$axios.get(this.url + 'getServices.php')
        .then((response) => {
          this.services = response.data
        })
    },
    kousin () {
      var self = this
      this.$axios.post(this.url + 'getLogs.php', JSON.stringify({
        kaisi: moment(this.calday).format('YYYY-MM-DD'),
        syuryo: moment(this.calday).add(1, 'months').format('YYYY-MM-DD'),
      })).then(function (res) {
        self.items = res.data
      })
    }
  }
}
</script>

<style lang="stylus">
  .appbar {
    min-width auto
  }
  .container {
    padding 5
  }
  table.v-table {
  }

</style>
